module.exports = "<a id=changeStatus href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn\"> {%- facStatus %} </a> <a href=# class=\"q-block-at-md q-text-center-at-md q-main-header-btn base-btn purple-btn editButton\"> <i class=\"fa fa-pencil q-icon-marg-right\"></i> Edit </a>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/facilities/html/changeStatusEditButton.html
// module id = 1291
// module chunks = 1